import Main from "./main/Main";
import "flatpickr/dist/themes/light.css";

export default function Root(props) {
  return <Main {...props} />;
}
